
import React, { useEffect } from 'react';
import { Header } from '../../components/feature/Header';
import { Footer } from '../../components/feature/Footer';
import { HeroSection } from './components/HeroSection';
import { AboutSection } from './components/AboutSection';
import { ServicesSection } from './components/ServicesSection';
import { ReviewsSection } from './components/ReviewsSection';
import { ContactSection } from './components/ContactSection';
import { QuoteSection } from './components/QuoteSection';

const HomePage: React.FC = () => {
  useEffect(() => {
    // Update page title
    document.title = 'Device Doctor Kochi - Expert Mobile & Laptop Repair Services Kerala';
    
    // Update meta description
    const updateMetaTag = (name: string, content: string) => {
      let meta = document.querySelector(`meta[name="${name}"]`);
      if (meta) {
        meta.setAttribute('content', content);
      } else {
        meta = document.createElement('meta');
        meta.setAttribute('name', name);
        meta.setAttribute('content', content);
        document.head.appendChild(meta);
      }
    };

    updateMetaTag('description', 'Device Doctor in Kochi offers expert mobile and laptop repair services with 10+ years experience. Same-day repairs, genuine parts, free pickup across Kerala. Call +91 8714014140 for iPhone, Samsung, Google Pixel repairs.');
    updateMetaTag('keywords', 'mobile repair kochi, phone repair kerala, laptop repair vyttila, device doctor, samsung repair, apple repair, google pixel repair, mobile service center kochi');

    // Add structured data for homepage
    const structuredData = {
      "@context": "https://schema.org",
      "@type": "WebPage",
      "name": "Device Doctor - Mobile & Laptop Repair Services Kochi",
      "description": "Expert mobile and laptop repair services in Kochi, Kerala with over 10 years of experience",
      "url": "https://devicedoctor.in/",
      "mainEntity": {
        "@type": "LocalBusiness",
        "name": "Device Doctor",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Store no 1, Near Nakshatra Jewellery, Vyttila Jn",
          "addressLocality": "Kochi",
          "addressRegion": "Kerala",
          "postalCode": "682019",
          "addressCountry": "IN"
        },
        "telephone": "+918714014140"
      }
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(structuredData);
    document.head.appendChild(script);

    return () => {
      // Cleanup script on unmount
      const scripts = document.querySelectorAll('script[type="application/ld+json"]');
      scripts.forEach(script => {
        if (script.textContent?.includes('WebPage')) {
          script.remove();
        }
      });
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <header>
          <h1 style={{ position: 'absolute', left: '-9999px' }}>Device Doctor - Expert Mobile & Laptop Repair Services in Kochi, Kerala</h1>
        </header>
        <HeroSection />
        <AboutSection />
        <ServicesSection />
        <ReviewsSection />
        <QuoteSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
};

export { HomePage };
export default HomePage;
